import React from 'react';
import PropTypes from 'prop-types';
import TransitionEventsPanel from "./TransitionEventsPanel";
import ActionsPanel from "./ActionsPanel";
import QueuesPanel from "./QueuesPanel";
import StateDiagram from './StateDiagram';
import queries from '../../graphql/queries';
import CircularProgress from 'material-ui/CircularProgress';
import OverlayController from '../overlay/OverlayController';
import TransitionEventSelectDialog from "./TransitionEventSelectDialog";
import mutationsWorkflow from '../../graphql/mutationsWorkflow';
import {Tabs, Tab} from 'material-ui/Tabs';
import { GraphQLStackTrace } from '../../utils/utils'
import { compose } from 'react-apollo';
import _ from 'lodash';
import './StateDiagram.css'

const STATE_TYPES = {
    NULL: "null",
    FROM_ANY: "fromAny",
    NORMAL: "normal"
};

export default compose(
    queries.projectQueryHocWithName('projectQuery'),
    queries.queuesQueryHocWithName('queuesQuery'),
    mutationsWorkflow.createFlowMutationHoc,
    mutationsWorkflow.updateFlowMutationHoc,
    mutationsWorkflow.deleteFlowMutationHoc,
    mutationsWorkflow.createStateMutationHoc,
    mutationsWorkflow.updateStateMutationHoc,
    mutationsWorkflow.deleteStateMutationHoc,
    mutationsWorkflow.createFromAnyStateMutationHoc,
    mutationsWorkflow.createNullStateMutationHoc,
    mutationsWorkflow.createTransitionMutationHoc,
    mutationsWorkflow.updateTransitionMutationHoc,
    mutationsWorkflow.deleteTransitionMutationHoc
)(class StateDiagramController extends React.Component {

    static propTypes = {
        projectQuery: PropTypes.object.isRequired,
        queuesQuery: PropTypes.object.isRequired,
        createFlow: PropTypes.func.isRequired,
        updateFlow: PropTypes.func.isRequired,
        deleteFlow: PropTypes.func.isRequired,
        createState: PropTypes.func.isRequired,
        updateState: PropTypes.func.isRequired,
        deleteState: PropTypes.func.isRequired,
        createFromAnyState: PropTypes.func.isRequired,
        createNullState: PropTypes.func.isRequired,
        createTransition: PropTypes.func.isRequired,
        updateTransition: PropTypes.func.isRequired,
        deleteTransition: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.stateDiagram = null;
        this.state = {
            saving: false,
            selection: null
        };
    }

    showSavingIndicator() {
        this.setState({saving: true});
    }

    hideSavingIndicator() {
        this.setState({saving: false});
    }

    render() {
        if (this.props.projectQuery.loading || this.props.queuesQuery.loading) {
            return (
                <CircularProgress className="activityIndicator"/>
            )
        } else if (this.props.projectQuery.error || this.props.queuesQuery.error) {
            return <pre>{GraphQLStackTrace(this.props.projectQuery.error || this.props.queuesQuery.error)}</pre>;
        }
        console.log("StateDiagramController.render(), props:", {props: this.props});
        return (
            <div className="diagram">
                <h2>Workflow</h2>
                <div className="stateDiagramFlexContainer">
                    <div className="stateDiagramSidebar">
                        <Tabs inkBarStyle={{height: 4, marginTop: -4}} className="stateDiagramSidebarTabs" contentContainerClassName="stateDiagramSidebarTabsContentContainer">
                            <Tab label="Events">
                                <TransitionEventsPanel project={this.props.projectQuery.project} delegate={this}/>
                            </Tab>
                            <Tab label="Actions">
                                <ActionsPanel project={this.props.projectQuery.project} delegate={this}/>
                            </Tab>
                            <Tab label="Queues">
                                <QueuesPanel
                                    project={this.props.projectQuery.project}
                                    queues={this.props.queuesQuery.queues}
                                    selection={this.state.selection}
                                    delegate={this}/>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="stateDiagramWrapper">
                        <StateDiagram
                            project={this.props.projectQuery.project}
                            delegate={this}
                            ref={(stateDiagram) => { this.stateDiagram = stateDiagram; } }
                        />
                        <div className="stateDiagramActivityIndicator" style={{display: this.state.saving ? "block" : "none"}}>
                            <CircularProgress color="#0077c2" size={14} thickness={2} style={{float: "left", marginRight: 6}} />
                            <span>saving...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // ====================================
    // QueuesPanel delegate methods
    // ====================================

    queuesPanelDidHighlightQueue(queue) {
        let states = {
            stateIdsIncluded: queue.itemFilter.stateIdsIncluded,
            stateIdsExcluded: queue.itemFilter.stateIdsExcluded
        };
        this.stateDiagram.highlightStates(states);
    }

    queuesPanelDidClearHighlight() {
        this.stateDiagram.clearHighlights();
        this.stateDiagram.highlightSelectedStates();
    }

    queuesPanelDidSelectQueue(queue) {
        // let states = {
        //     stateIdsIncluded: queue.itemFilter.stateIdsIncluded,
        //     stateIdsExcluded: queue.itemFilter.stateIdsExcluded
        // };
        // this.stateDiagram.selectStates(states);
    }

    queuesPanelDidCreateQueue() {
        this.stateDiagram.clearSelection();
    }

    // =====================================
    // ActionsPanel delegate methods
    // =====================================

    actionPanelDidCreateAction() {
        let links = this.linkDataForStateDiagram();
        this.stateDiagram.updateLinkActions(links);
    }

    actionPanelDidUpdateAction() {
        let links = this.linkDataForStateDiagram();
        this.stateDiagram.updateLinkActions(links);
    }

    actionPanelDidDeleteAction() {
        let links = this.linkDataForStateDiagram();
        this.stateDiagram.updateLinkActions(links);
    }

    // ==============================================
    // TransitionEventsPanel delegate methods
    // ==============================================

    transitionEventsPanelDidCreateTransitionEvent(transitionEvent) {

    }

    transitionEventsPanelDidUpdateTransitionEvent(transitionEvent) {
        this.props.projectQuery.project.transitions.forEach(transition => {
            if (transition.transitionEventId === transitionEvent.id) {
                this.stateDiagram.updateLinkText(transition.id, transitionEvent.name);
            }
        });
    }

    transitionEventsPanelDidDeleteTransitionEvent(transitionEventId) {

    }

    // =============================
    // StateDiagram delegate methods
    // =============================

    stateDiagramDidSelectMixedObjects() {
        this.setState({selection: null});
        this.stateDiagram.clearHighlights();
    }

    stateDiagramDidSelectTransition(transitionId) {
        let transition = _.find(this.props.projectQuery.project.transitions, {id: transitionId});
        this.setState({selection: {
            type: 'transition',
            transition: transition
        }});
    }

    stateDiagramDidSelectStates(data) {
        this.setState({selection: {
            type: 'states',
            states: data
        }});
        this.stateDiagram.highlightSelectedStates();
    }

    stateDiagramDidCreateFlow(data, complete) {
        console.log("stateDiagramDidCreateFlow:", data);
        OverlayController.showActivityIndicator();
        this.props.createFlow(this.props.projectQuery.project.id, data.flowName, data.flowLocation)
            .then(({data}) => {
                console.log("flow created:", data.createFlow);
                complete(data.createFlow);
                OverlayController.hideActivityIndicator();
            })
            .catch((error) => {
                console.log(error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    stateDiagramDidUpdateFlow(data) {
        console.log("stateDiagramDidUpdateFlow:", data);
        this.showSavingIndicator();
        this.props.updateFlow(data.flowId, data.flowName, data.flowLocation)
            .then(({data}) => {
                console.log("flow updated:", data.updateFlow);
                this.hideSavingIndicator();
            })
            .catch((error) => {
                console.log(error);
                this.hideSavingIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    stateDiagramDidDeleteFlow(data) {
        console.log("stateDiagramDidDeleteFlow:", data);
        this.showSavingIndicator();
        this.props.deleteFlow(data.flowId)
            .then(({data}) => {
                console.log("flow deleted:", data.deleteFlow);
                this.hideSavingIndicator();
            })
            .catch((error) => {
                console.log(error);
                this.hideSavingIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    stateDiagramDidCreateState(data, complete) {
        console.log("stateDiagramDidCreateState:", data);
        OverlayController.showActivityIndicator();
        this.props.createState(data.flowId, data.stateName, data.stateLocation)
            .then(({data}) => {
                console.log("state created:", data.createState);
                complete(data.createState);
                OverlayController.hideActivityIndicator();
            })
            .catch((error) => {
                console.log(error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    stateDiagramDidUpdateState(data) {
        console.log("stateDiagramDidUpdateState:", data);
        this.showSavingIndicator();
        this.props.updateState(data.stateId, data.stateName, data.stateLocation)
            .then(({data}) => {
                console.log("state updated:", data.updateState);
                this.hideSavingIndicator();
            })
            .catch((error) => {
                console.log(error);
                this.hideSavingIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    stateDiagramDidDeleteState(data) {
        console.log("stateDiagramDidDeleteState:", data);
        this.showSavingIndicator();
        this.props.deleteState(data.stateId)
            .then(({data}) => {
                console.log("state deleted:", data.deleteState);
                this.hideSavingIndicator();
            })
            .catch((error) => {
                console.log(error);
                this.hideSavingIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    stateDiagramDidCreateFromAnyState(data, complete) {
        console.log("stateDiagramDidCreateFromAnyState:", data);
        OverlayController.showActivityIndicator();
        this.props.createFromAnyState(data.flowId, data.stateLocation)
            .then(({data}) => {
                console.log("fromAny state created:", data.createFromAnyState);
                complete(data.createFromAnyState);
                OverlayController.hideActivityIndicator();
            })
            .catch((error) => {
                console.log(error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    stateDiagramDidCreateNullState(data, complete) {
        console.log("stateDiagramDidCreateNullState:", data);
        OverlayController.showActivityIndicator();
        this.props.createNullState(this.props.projectQuery.project.id, data.stateLocation)
            .then(({data}) => {
                console.log("null state created:", data.createNullState);
                complete(data.createNullState);
                OverlayController.hideActivityIndicator();
            })
            .catch((error) => {
                console.log(error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    stateDiagramDidInsertLink(data, callback) {
        console.log("stateDiagramDidInsertLink:", data);
        OverlayController.showOverlay({
            component: <TransitionEventSelectDialog project={this.props.projectQuery.project} callback={transitionEvent => {
                let transitionInput = {
                    transitionEventId: transitionEvent.id,
                    stateFromId: data.stateFromId,
                    stateToId: data.stateToId
                };
                OverlayController.showActivityIndicator();
                this.props.createTransition(this.props.projectQuery.project.id, transitionInput)
                    .then(({data}) => {
                        console.log("transition created:", data.createTransition);
                        OverlayController.hideActivityIndicator();
                        let linkData = this.linkDataForTransition(data.createTransition);
                        callback(linkData);
                    })
                    .catch((error) => {
                        console.log(error);
                        OverlayController.hideActivityIndicator();
                        OverlayController.showErrorAlert(error);
                        callback(null);
                    });
            }}/>,
            onDidHide: () => {callback(null);}
        });
    }

    stateDiagramDidClickChangeTransitionEvent(transitionId) {
        let transition = _.find(this.props.projectQuery.project.transitions, {id: transitionId});
        let transitionEventId = transition ? transition.transitionEventId : null;
        OverlayController.showOverlay({
            component: <TransitionEventSelectDialog project={this.props.projectQuery.project} transitionEventId={transitionEventId} callback={(transitionEvent) => {
                let transitionInput = {
                    transitionEventId: transitionEvent.id
                };
                OverlayController.showActivityIndicator();
                this.props.updateTransition(transitionId, transitionInput)
                    .then(({data}) => {
                        console.log("transition updated:", data.updateTransition);
                        OverlayController.hideActivityIndicator();
                        let linkData = this.linkDataForTransition(data.updateTransition);
                        this.stateDiagram.updateLinkData(linkData);
                    })
                    .catch((error) => {
                        console.log(error);
                        OverlayController.hideActivityIndicator();
                        OverlayController.showErrorAlert(error);
                    });
            }}/>
        });
    }

    stateDiagramDidDeleteTransition(transitionId) {
        console.log("stateDiagramDidDeleteTransition:", transitionId);
        this.showSavingIndicator();
        this.props.deleteTransition(transitionId)
            .then(({data}) => {
                console.log("transition deleted:", data.deleteTransition);
                this.hideSavingIndicator();
            })
            .catch((error) => {
                console.log(error);
                this.hideSavingIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    linkDataForStateDiagram() {
        let cache = {};
        return this.props.projectQuery.project.transitions.map(transition => {
            return this.linkDataForTransition(transition, cache);
        });
    }

    /**
     * Creates data for diagram link from transition.
     *
     * The link data has the "hasAction" attribute which indicates that the link will be rendered with an action
     * indicator specifying that the transition can have an action that will be rendered within the item dialog.
     * To decide if a transition can have an action (hasAction = true), the following logic is applied:
     *
     * - if transition.transitionEventId !== action.transitionEventId, then: hasAction = false
     * - else if transition.stateFrom is of type "null, then: hasAction = true
     * - else if action.itemFilter.excludeAllStates === true, then: hasAction = false
     * - else if transition.stateFrom is of type "fromAny" then:
     *     - if all "normal" states in transition.stateFrom.flow are in action.itemFilter.stateIdsExcluded, then: hasAction = false
     *     - else: hasAction = true
     * - else if action.itemFilter.stateIdsIncluded have a state in the same flow as transition.stateFrom then:
     *     - if transition.stateFromId is in action.itemFilter.stateIdsIncluded, then: hasAction = true
     *     - else: hasAction = false
     * - else if transition.stateFromId is in action.itemFilter.stateIdsExcluded, then: hasAction = false
     * - else: hasAction = true
     *
     * @param transition
     * @param cache
     * @return {{key: string, text: string, hasAction: boolean, from: string, to: string}} The data for a diagram link.
     */
    linkDataForTransition(transition, cache = {}) {
        if (!Object.keys(cache).length) {
            let project = this.props.projectQuery.project;
            Object.assign(cache, {
                transitionEventsById: _.keyBy(project.transitionEvents, 'id'),
                statesById: _.keyBy(project.states, 'id'),
                normalStateIdsGroupedByFlowId: _(project.states).filter({type: STATE_TYPES.NORMAL}).groupBy('flowId').value(),
                actionsGroupedByTransitionEventId: _(project.actions).filter('transitionEventId').groupBy('transitionEventId').value()
            });
        }
        let transitionEventsById = cache.transitionEventsById;
        let statesById = cache.statesById;
        let normalStateIdsGroupedByFlowId = cache.normalStateIdsGroupedByFlowId;
        let actionsGroupedByTransitionEventId = cache.actionsGroupedByTransitionEventId;

        let hasAction = false;
        if (transition.transitionEventId in actionsGroupedByTransitionEventId) {
            let stateFrom = statesById[transition.stateFromId];
            hasAction = _.some(actionsGroupedByTransitionEventId[transition.transitionEventId], action => {
                if (stateFrom.type === STATE_TYPES.NULL) {
                    return true;
                }
                if (action.itemFilter.excludeAllStates) {
                    return false;
                }
                if (stateFrom.type === STATE_TYPES.FROM_ANY) {
                    return _.difference(normalStateIdsGroupedByFlowId[stateFrom.flowId], action.itemFilter.stateIdsExcluded).length !== 0;
                }
                if (_.some(action.itemFilter.stateIdsIncluded, stateId => statesById[stateId].flowId === stateFrom.flowId)) {
                    return _.includes(action.itemFilter.stateIdsIncluded, transition.stateFromId);
                }
                return !_.includes(action.itemFilter.stateIdsExcluded, transition.stateFromId);
            });
        }
        return {
            key: transition.id,
            text: transitionEventsById[transition.transitionEventId].name,
            hasAction: hasAction,
            from: transition.stateFromId,
            to: transition.stateToId
        }
    }

});



// WEBPACK FOOTER //
// ./src/components/diagram/StateDiagramController.js